import { dateFormat } from '@constants/dateFormat'
import { GraviButton, Horizontal } from '@gravitate-js/excalibrr'
import { formatters } from '@utils/intl/dateTimeFormatters'
import dayjs from 'dayjs'
import { useState } from 'react'
import type { DateControlOptions } from '../types'
import ButtonGroup from 'antd/es/button/button-group'
import { DatePicker, TimePicker } from 'antd'

type SpecificTimeOrNowFilterProps = {
  onChange: (dateTime: string, dateControl: DateControlOptions) => void
  filters: {
    as_of: string
    date_control: DateControlOptions
  }
}

export function SpecificTimeOrNowFilter({ onChange, filters }: SpecificTimeOrNowFilterProps) {
  function setDateView(dateControl: DateControlOptions) {
    onChange(filters.as_of, dateControl)
  }

  function onSpecificChange(inputChanged: 'day' | 'time', value: dayjs.Dayjs) {
    const newDate =
      inputChanged === 'day' ? value.format(dateFormat.DATE) : dayjs(filters.as_of).format(dateFormat.DATE)
    const newTime =
      inputChanged === 'time' ? value.format(dateFormat.TIME) : dayjs(filters.as_of).format(dateFormat.TIME)
    onChange(dayjs(`${newDate} ${newTime}`).startOf('minute').toISOString(), 'Specific')
  }

  function onNowChange() {
    const now = dayjs().startOf('minute').toISOString()
    onChange(now, 'Now')
  }

  return (
    <Horizontal gap={8}>
      <ButtonGroup>
        <GraviButton
          className=' price-management-date-filter'
          theme2={filters.date_control === 'Now'}
          buttonText='Now'
          onClick={onNowChange}
        />
        <GraviButton
          className=' price-management-date-filter'
          theme2={filters.date_control === 'Specific'}
          buttonText='Specific Time'
          onClick={() => setDateView('Specific')}
        />
      </ButtonGroup>
      {filters.date_control === 'Specific' && (
        <>
          <DatePicker
            defaultValue={dayjs(filters.as_of)}
            onChange={(date) => onSpecificChange('day', date)}
            format={formatters.DATE}
            style={{ minWidth: '100px' }}
            allowClear={false}
          />
          <TimePicker
            defaultValue={dayjs()}
            format={formatters.TIME}
            onChange={(value) => onSpecificChange('time', value)}
            allowClear={false}
            use12Hours
            showSecond={false}
          />
        </>
      )}
    </Horizontal>
  )
}
